import { render, staticRenderFns } from "./RuleSetBuilderIframe.vue?vue&type=template&id=38e0e89a&scoped=true"
import script from "./RuleSetBuilderIframe.vue?vue&type=script&lang=js"
export * from "./RuleSetBuilderIframe.vue?vue&type=script&lang=js"
import style0 from "./RuleSetBuilderIframe.vue?vue&type=style&index=0&id=38e0e89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0e89a",
  null
  
)

export default component.exports